import { React, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import axios from "axios";
import download from "downloadjs";
import { base64 } from "../../../../constants/validate";
import { ReactComponent as Check } from "../../../../assets/check.svg";
import { Button, Tooltip } from "../../../../components/DesignSystem";

import "./index.scss";
import env from "../../../../env";

export default function Signature() {
  const { currentCase } = useSelector((state) => state.crm);
  const { signatures } = currentCase;
  const [loading, setLoading] = useState(false);

  function returnClassNameCheck(signed) {
    let className = "signature__check";

    if (signed === 1) className += " signature__check--active";

    return className;
  }

  function disableButton() {
    return signatures.every((signature) => signature.signed === 1);
  }

  function downloadMinute() {
    setLoading(true);
    let token =
      env === "development"
        ? "830b013e0b3a4112b20db7673bfb303d"
        : "93787308c6904130959e60dc4af0e379";
    let headers = { headers: { token } };
    axios
      .get(currentCase.case.document_url, headers)
      .then((response) => {
        download(
          base64(response.data.bytes),
          response.data.name,
          response.data.mimeType
        );
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }
  return (
    <div className="signature">
      <ul className="signature__list">
        {_.orderBy(signatures, "step", "asc").map((signature) => (
          <li key={signature.id}>
            <div className={returnClassNameCheck(signature.signed)}>
              {signature.signed === 1 && <Check />}
            </div>
            <p className="signature__user-name">{signature.name}</p>
          </li>
        ))}
      </ul>
      {/* <Button
        contained
        fullWidth
        disabled={!currentCase.case.document_url}
        onClick={() => downloadMinute()}
        loading={loading}
      >
        Baixar documento
      </Button> */}
    </div>
  );
}
